export default __webpack_public_path__ + "static/media/resumeNew.74293ae9.png";